import { useEffect, useState } from "react";
import { MiniCountdown } from "./MiniCountdown";
import {
  formatSessionShort,
  getNextSession,
} from "@/lib/selecao-sessions";

/**
 * Sticky CTA mobile — discreto, 2 linhas: CTA + countdown condensado.
 * Aparece após scroll > 600px (passou do hero).
 */
export const SelecaoStickyCTA = () => {
  const [show, setShow] = useState(false);
  const next = getNextSession();
  const short = formatSessionShort(next.date);

  useEffect(() => {
    const handleScroll = () => setShow(window.scrollY > 600);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`md:hidden fixed bottom-0 left-0 right-0 z-40 transition-transform duration-300 ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
      aria-hidden={!show}
    >
      <div className="bg-white/95 backdrop-blur border-t border-zinc-200 px-4 py-3">
        <a
          href="#form"
          className="w-full inline-flex flex-col items-center justify-center gap-0.5 rounded-full px-4 py-2.5 font-semibold bg-[#112711] text-white text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#112711]"
        >
          <span>Reservar minha vaga</span>
          <span className="text-[10px] font-medium text-[#D1F8E2]/80">
            {short} · faltam <MiniCountdown target={next.date} />
          </span>
        </a>
      </div>
    </div>
  );
};
